var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics"},[_c('div',{staticClass:"title"},[_vm._v("报警处理情况")]),_c('div',{staticClass:"warp-block"},[_c('Police')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }